export const googleDriveType = 'googledrive';
